import { Controller } from "@hotwired/stimulus"

// Auto-dismisses a transient chat status note (e.g. "A specialist has been notified")
// a few seconds after it appears, so the thread doesn't accumulate stale banners. The
// state change is also announced by an in-thread system message, so nothing is lost.
export default class extends Controller {
  connect() {
    this.timer = setTimeout(() => this.element.remove(), 6000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
